import MembMktgAgreInqApi from "Apis/MembMktgAgreInqApi";
import MembMktgAgreChngApi from "Apis/MembMktgAgreChngApi";
import { ChangeEvent, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MgpStore from "Stores/Store";
import MembQnaLstApi from "Apis/MembQnaLstApi";




const MembQnaTop1Ui = ({langData}:any) => {
    const [ctntCtxtState,setCtntCtxtState] = useState<any>();
   useEffect(()=>{
        MembQnaLstApi("MGP",1,"").then((resp)=>{
             setCtntCtxtState(resp.apiBody.qnaLst);
        })
      },[MgpStore.getState().LangSetState.Lang]);

    return(
        <div className="myPageCard">
            <h2>My QnA</h2>
            <div className="myPageCardCtxt">
                <ul>
                    <li className="myPageCardCtxtLi">
                        {ctntCtxtState&&ctntCtxtState.length > 0 ? 
                            <Link className="myPageCardQnaATag" to={`/MyPage/QnaCtxt?gameSvcCd=${ctntCtxtState[0].gameSvcCd}&ctntKindCd=QNA&qnaSno=${ctntCtxtState[0].qnaSno}`}>
                                <div className="ctxtLiTitl qnaCtxtLiTitl">
                                    <p>{ctntCtxtState[0].qnaTitl}</p>
                                </div>
                                <div>
                                    <p className={`rplCol${ctntCtxtState[0].rplYn}`}>{langData&&langData[`MYPAGE_QNA_RPL_${ctntCtxtState[0].rplYn}_LBL_00`]}</p>
                                </div>
                            </Link>:
                            <div className="ctxtLiTitl qnaCtxtLiTitl">
                                <p>{langData&&langData.GLB_NO_DATA_LBL_00}</p>
                            </div>
                        }
                    </li>
                </ul>
                <div className="mypageQnaBtnWrap">
                    <Link to={"/MyPage/QnaLst?gameSvcCd=MGP&ctntKindCd=QNA"}>
                        <p>
                            {langData&&langData.MYPAGE_MAIN_QNA_LST_BTN_00}
                        </p>
                        {/* 문의 내역보기 */}
                    </Link>
                    <Link to={"/MyPage/QnaWrite?gameSvcCd=MGP"}>
                        <p>
                            {langData&&langData.MYPAGE_MAIN_QNA_REG_BTN_00}
                        </p>
                        {/* 1:1 문의하기 */}
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default MembQnaTop1Ui;